/**
 * @desc 编辑sku报关信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmSkuCustomsEditRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/editSkuCustomsClearance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
